module.exports = __webpack_public_path__ + "assets/c552159d41c15e0eeac4c2023d89d6dd-DSC_0776.jpg";